import PropTypes from 'prop-types';
import { graphql, useFragment } from 'react-relay';
import { getFilterValues } from '../sbSharedRefineMenuHelpers.ts';

// components
import { SbSharedRefineMenuMultiSelect } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelect.tsx';
import { SbSharedRefineMenuTypeaheadContainer } from '../SbSharedRefineMenuTypeahead/SbSharedRefineMenuTypeaheadContainer.jsx';

const viewerFragment = graphql`
    fragment SbSharedRefineMenuMultiSelectSearch_viewer on Viewer {
        ...SbSharedRefineMenuTypeaheadContainer_viewer
    }
`;
const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuMultiSelectSearch_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuTypeaheadContainer_itemSearch
        appliedFilters {
            name
            localizedFilterName
            canBeDismissed
            values {
                urlLabel
                linkReference
                count
                displayName
            }
        }
    }
`;

export const SbSharedRefineMenuMultiSelectSearch = ({
    viewer: viewerRef,
    itemSearch: itemSearchRef,
    values,
    filterName,
    collapsedItemCount,
    showSearchBar,
    trackingOptions,
}) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const { appliedFilters } = itemSearch;

    const appliedFilterValues = getFilterValues(appliedFilters, filterName);

    return (
        <SbSharedRefineMenuTypeaheadContainer
            appliedFilterValues={appliedFilterValues}
            filterName={filterName}
            availableFilterValues={values}
            viewer={viewer}
            itemSearch={itemSearch}
            collapsedItemCount={collapsedItemCount}
            showSearchBar={showSearchBar}
            trackingOptions={trackingOptions}
        >
            {({ valuesToShow }) => (
                <SbSharedRefineMenuMultiSelect
                    filterName={filterName}
                    appliedFilterValues={appliedFilterValues}
                    valuesToShow={valuesToShow}
                    trackingOptions={trackingOptions}
                />
            )}
        </SbSharedRefineMenuTypeaheadContainer>
    );
};

SbSharedRefineMenuMultiSelectSearch.propTypes = {
    viewer: PropTypes.object.isRequired,
    itemSearch: PropTypes.object.isRequired,
    filterName: PropTypes.string.isRequired,
    collapsedItemCount: PropTypes.number,
    values: PropTypes.array.isRequired,
    showSearchBar: PropTypes.bool,
    trackingOptions: PropTypes.object,
};
